export default __webpack_public_path__ + "static/media/akthe_CA_1112.6f63b6e0.png";